import { toast } from 'sonner';

export const showSuccess = (message: string) => toast.success(message);
export const showError = (message: string) => toast.error(message);
export const showWarning = (message: string) => toast.warning(message);
export const showInfo = (message: string) => toast.info(message);
export const showLoading = (message: string) => toast.loading(message);

export const showPromise = <T>(
  promise: Promise<T>,
  opts: { loading: string; success: string; error: string },
) => toast.promise(promise, opts);
